import { Card, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import DefaultVideo from "../../video/English V _ HS(1080P_HD).mp4";
import "../../components/CSS/Tutorial-page/Tutorial.css";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { serverInfo } from "../../App";

export const SliderTutorial = () => {

  const { videoCdnUrl } = useContext(serverInfo);

  const [loading, setLoading] = useState(true);
  const [link, setLink] = useState("");
  const [video, setVideo] = useState("");
  useEffect(() => {
    axios.get(`/api/virtualtourforweb`).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setLink(res.data?.data.link);
        setVideo(res.data?.data?.video);
      }
    });
  }, []);
  return (
    <>
      <div className="tbg-img">
        <section id="header" className="d-flex align-items-center">
          <div className="container-fluid">
            <div className="row">
              <div className="col-10 mx-auto">
                <div className="row">
                  <div className="col-md-6 pt-5 pt-lg-0 order-1 order-lg-1 d-flex justify-content-center flex-column">
                    <div className="mt-3"></div>
                  </div>

                  <div className="col-lg-12 order-2 order-lg-2 header-img">
                    <Container
                      className="d-flex align-items-center justify-content-center"
                      style={{ minHeight: "100vh" }}
                    >
                      <div
                        className="st tu-video-play-start "
                        style={{ maxWidth: "750px" }}
                      >
                        <Card className="stIn-bg">
                          <Card.Body>
                            {
                              video && <video
                                className="Video-paly d-block"
                                src={videoCdnUrl + video}
                                controls
                                autoPlay></video> ||
                              link && <iframe width="700" height="400" src={link}></iframe> ||
                              <video
                                className="Video-paly d-block"
                                src={DefaultVideo}
                                controls
                                autoPlay></video>
                            }
                          </Card.Body>
                          <Link to="/login">
                            <button className="skip mb-3">Skip</button>
                          </Link>
                        </Card>
                      </div>
                    </Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default SliderTutorial;
